"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("ayvri-ui/lib/styles");
var typestyle_1 = require("typestyle");
var styles_2 = require("../../styles");
var styles_3 = require("../../styles");
exports.kSceneCardWidth = '22.265rem';
var list = typestyle_1.style({
    display: 'grid',
    gridTemplateColumns: "repeat(auto-fill, " + exports.kSceneCardWidth + ")",
    gridColumnGap: styles_3.kGap,
    gridRowGap: styles_3.kGap,
}, styles_2.forMobile({
    gridTemplateColumns: '1fr',
    padding: "0 " + styles_3.kHalfGap,
    $nest: {
        '&:first-child': {
            paddingTop: styles_3.kGap,
        },
    },
}));
var cardContainer = typestyle_1.style({
    height: '16.25rem',
    $nest: {
        '& > a': {
            height: '100%',
        },
    },
});
var card = typestyle_1.style({
    border: '1px solid #ddd',
    background: '#f8f8f8',
    borderRadius: '5px',
    overflow: 'hidden',
});
var sceneActions = typestyle_1.style({
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: '1fr 24px 24px',
    gridColumnGap: '5px',
    height: '24px',
    padding: '10px 8px',
    alignItems: 'center',
    $nest: {
        '& > a > svg': {
            height: '100%',
            width: '100%',
        },
    },
});
// this is a rather hack way to hide the edit link on a mobile device,
// but for now it's ok given we don't really expect people to be inspecting
// the DOM on their mobile device.  If they are interested in doing so, they
// deserve to find the link but suffer the eventual dissapointment that studio
// does not work on a mobile device
var studioEditLink = typestyle_1.style(styles_2.forMobile({
    visibility: 'hidden',
}));
var moreResults = typestyle_1.style({
    color: styles_1.getHex('white'),
});
var featuredScenes = typestyle_1.style({
    marginTop: '4rem',
    justifyContent: 'center',
    $nest: {
        '& > h3': {
            // TODO (damon) - these styles are copied from the existing website
            // should really be normalized into ayvri text styles
            fontSize: '0.875rem',
            color: '#999',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: 700,
            marginBottom: '1rem',
        },
    },
});
var featuredGrid = typestyle_1.style({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridRowGap: '10px',
    gridColumnGap: '10px',
    $nest: {
        '& > div': {
            borderRadius: '5px',
            overflow: 'hidden',
        },
    },
}, styles_2.forMobile({
    gridTemplateColumns: '1fr',
}));
exports.styles = {
    list: list,
    cardContainer: cardContainer,
    card: card,
    sceneActions: sceneActions,
    studioEditLink: studioEditLink,
    moreResults: moreResults,
    featuredScenes: featuredScenes,
    featuredGrid: featuredGrid,
};
